/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EmprestimoGarantiaCarroMaisLonge.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';

function EmprestimoGarantiaCarroMaisLonge() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="emp-garantia-carro-mais-longe">
        <ContainerHome24>
          <div className="mais-longe-imagens">
            <picture>
              <source
                type="image/webp"
                srcSet="assets/emprestimo-garantia-carro/mais-longe-iphone.webp"
              />
              <source
                type="image/png"
                srcSet="assets/emprestimo-garantia-carro/mais-longe-iphone.png"
              />
              <img
                src="assets/emprestimo-garantia-carro/mais-longe-iphone.png"
                alt=""
                className="mais-longe-iphone"
                width="524"
                height="595"
              />
            </picture>
            <picture>
              <source
                type="image/webp"
                srcSet="assets/emprestimo-garantia-carro/mais-longe-img-proposta.webp"
              />
              <source
                type="image/png"
                srcSet="assets/emprestimo-garantia-carro/mais-longe-img-proposta.png"
              />
              <img
                src="assets/emprestimo-garantia-carro/mais-longe-img-proposta.png"
                alt=""
                className="mais-longe-img-proposta"
                width="665"
                height="921"
              />
            </picture>
          </div>
          <div className="mais-longe-textos">
            <h3 className="mais-longe-titulo">
              Com a Santander Financiamentos, você vai mais longe
            </h3>
            <div className="mais-longe-cards">
              <div className="mais-longe-card">
                <img src="assets/emprestimo-garantia-carro/ic_clock_urgent.svg" alt="" />
                <p className="mais-longe-card-texto">
                  Descubra sua oferta em até 2 minutos, receba em até 24h úteis.
                </p>
              </div>
              <div className="mais-longe-card">
                <img src="assets/emprestimo-garantia-carro/ic_offer.svg" alt="" />
                <p className="mais-longe-card-texto">
                  5% de desconto na taxa de juros escolhendo débito automático em conta Santander
                  como forma de pagamento.
                </p>
              </div>
              <div className="mais-longe-card">
                <img src="assets/emprestimo-garantia-carro/ic_digital_chanel.svg" alt="" />
                <p className="mais-longe-card-texto">
                  É fácil fazer sua vistoria, online, sem agendamentos e sem taxas.
                </p>
              </div>
              <div className="mais-longe-card">
                <img src="assets/emprestimo-garantia-carro/ic_face_id.svg" alt="" />
                <p className="mais-longe-card-texto">
                  Todo processo de contratação é 100% online e a assinatura do contrato é feita com
                  sua selfie.
                </p>
              </div>
            </div>
            <RedButton
              href="https://emprestimosim.com.br/app/#/onboarding/signUp"
              target="_blank"
              className="mais-longe-btn-simular"
            >
              Começar simulação
            </RedButton>
          </div>
        </ContainerHome24>
      </section>
      {typeof window === 'undefined' ? (
        <></>
      ) : (
        <>
          {width <= 500 && (
            <picture>
              <source
                type="image/webp"
                srcSet="assets/emprestimo-garantia-carro/img-separacao-mobi.webp"
              />
              <source
                type="image/png"
                srcSet="assets/emprestimo-garantia-carro/img-separacao-mobi.png"
              />
              <img
                src="assets/emprestimo-garantia-carro/img-separacao-mobi.png"
                alt="Homem branco pesquisando informações sobre o empréstimo com garantia de veículo na Santander Financiamentos."
                className="emp-garantia-carro-img-separacao"
                width="320"
                height="300"
              />
            </picture>
          )}
          {width > 500 && (
            <picture>
              <source
                type="image/webp"
                srcSet="assets/emprestimo-garantia-carro/img-separacao.webp"
              />
              <source
                type="image/png"
                srcSet="assets/emprestimo-garantia-carro/img-separacao.png"
              />
              <img
                src="assets/emprestimo-garantia-carro/img-separacao.png"
                alt="Homem branco pesquisando informações sobre o empréstimo com garantia de veículo na Santander Financiamentos."
                className="emp-garantia-carro-img-separacao"
                width="1440"
                height="320"
              />
            </picture>
          )}
        </>
      )}

      <style jsx>{Style}</style>
    </>
  );
}

export default EmprestimoGarantiaCarroMaisLonge;
